export function getView(type) {
  return type === 'existing' ? 'Related' : 'Form'
}
